<v4-custom-select
  [size]="size"
  [showTextItem]="showTextItem"
  [textItem]="textItem"
  [placeholder]="placeholder | translate"
  [(visible)]="dropdownVisible">
  <div class="v4-layout-dropdown w-[700px]">
    <v4-base-selector-body
      class="block"
      style="height: calc(100% - 60px)"
      [mode]="mode"
      [listOfOption]="listOfData"
      [selectedValues]="selectedValues"
      (onSelect)="onSelect($event)"
      (onConfirm)="onConfirm($event)"
      (onCancel)="onCancel()"
      (onReset)="onReset()">
      <div class="v4-base-selector-body_filters" [formGroup]="form">
        <div class="v4-filter-list overflow-x-auto mb-3" *ngIf="listOfTagOption?.length">
          <div class="v4-filter-item">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="tagId === null"
              (click)="form.patchValue({ house_tag_id: null })">
              {{ "word.select_option.placeholder.tag" | translate }}
              <!-- Tag -->
            </div>
          </div>
          <div class="v4-filter-item" *ngFor="let tag of listOfTagOption">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="tagId === tag.value"
              (click)="form.patchValue({ house_tag_id: tag.value })"
              style="background-color: #fff">
              {{ tag.label }}
            </div>
          </div>
        </div>
      </div>
    </v4-base-selector-body>
  </div>
</v4-custom-select>
